import React, {Component} from 'react';
import {gpn} from "../GPN"
import axios from "axios";
import config from "../config";
import Icon from "../sections/MUI/Icon";

class Dashboard extends Component {

    state = {
        onlineUsers: "",
        orders: 0,
        toMonthOrders: 0,
        lastMonthOrders: 0,
        services: 0,
        toMonthServices: 0,
        lastMonthService: 0,
        payments: 0,
        toMonthPayments: 0,
        lastMonthPayments: 0
    };

    componentDidMount() {
        config.scrollTop();
        this.getDashboard();
    }


    getDashboard() {
        axios.get(`${config.api}/admin/dashboard?token=${config.token}`)
            .then(r => {
                this.setState({...r.data.result});
            })
            .catch(err => {
                config.handleError(err)
            });
    }


    render() {
        const {
            orders,
            toMonthOrders,
            lastMonthOrders,
            services,
            payments,
            toMonthPayments,
            lastMonthPayments
        } = this.state;
        return (
            <div className="dashboard">

                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <p><span>کل سفارشات:</span><span>{orders}</span></p>
                    </div>
                    <div className="col-md-6">
                        <p><span>سفارشات این ماه:</span><span>{toMonthOrders}</span></p>
                    </div>
                    <div className="col-md-6">
                        <p><span>سفارشات ماه گذشته:</span><span>{lastMonthOrders}</span></p>
                    </div>
                    <div className="col-md-6">
                        <p><span>سرویس ها:</span><span>{services}</span></p>
                    </div>
                    <div className="col-md-6">
                        <p><span>کل پرداخت ها:</span><span>{payments}</span></p>
                    </div>
                    <div className="col-md-6">
                        <p><span>پرداخت های این ماه:</span><span>{toMonthPayments}</span></p>
                    </div>
                    <div className="col-md-6">
                        <p><span>پرداخت های ماه گذشته:</span><span>{lastMonthPayments}</span></p>
                    </div>
                </div>
            </div>
        );
    }
}

export default gpn(Dashboard);